/**
 * Created by Gaplo917 on 15/7/2017.
 * Wrapper for howler
 * https://github.com/goldfire/howler.js#documentation
 */
import * as GameUtils from "./GameUtils";
import * as Rx from "rxjs";
import * as Events from "./Events"


export class CreateJsSound {
  constructor({id,volume, loop}){
    this.id = id
    this.volume = volume
    // createjs Sound using loop count instead of loop boolean, 100000 should be more than enough for infinity loop
    this.loop = loop ? 100000 : 0
    this.instance = null
  }
  play(onComplete){
    console.log(`playing ${this.id} with volume ${this.volume}`)
    if(GameUtils.isIE11()){
      if(createjs.Sound.loadComplete(this.id)){
        this.instance = createjs.Sound.play(this.id, { loop: this.loop })
        this.instance.volume = this.volume

        if(typeof onComplete === 'function'){
          this.instance.on('complete', () => onComplete())
        }
      }
      else {
        createjs.Sound.registerSound(this.id, this.id, 2)
        Rx.Observable.interval(16)
          .filter(() => createjs.Sound.loadComplete(this.id))
          .take(1)
          .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
          .subscribe(() => {
            this.instance = createjs.Sound.play(this.id, { loop: this.loop })
            this.instance.volume = this.volume

            if(typeof onComplete === 'function'){
              this.instance.on('complete', () => onComplete())
            }
          })
      }
    }
    else {

      this.instance = createjs.Sound.play(this.id, { loop: this.loop })
      this.instance.volume = this.volume

      if(typeof onComplete === 'function'){
        this.instance.on('complete', () => onComplete())
      }

    }

  }

  stop(){
    if(this.instance){
      this.instance.stop()
    }
  }
}


export function create(opt){
  const src = Array.isArray(opt.src) ? opt.src[0] : opt.src
  const id = src // use src as Id
  const volume = opt.volume
  const loop = opt.loop || false
  return new CreateJsSound({id, volume, loop})
}


// WEBPACK FOOTER //
// ./src/game/SoundUtils.js